import trans from '../../helpers/trans';
import { NavRoute } from '../routes';

export type AuthRouteKey =
    'login'
    | 'resetPassword'
    | 'requestPasswordReset'
    | 'samlReturn';

export const AuthRoutes = {
    login: () => '',
    resetPassword: () => trans('routes.resetPassword.link'),
    requestPasswordReset: () => trans('routes.requestPasswordReset.link'),
    samlReturn: () => trans('routes.samlReturn.link'),
};

const authRoutes: NavRoute[] = [
    {
        key: 'login',
        path: AuthRoutes.login(),
        label: trans('routes.login.label'),
        children: [],
    },
    {
        key: 'resetPassword',
        path: AuthRoutes.resetPassword(),
        label: trans('routes.resetPassword.label'),
        children: [],
    },
    {
        key: 'requestPasswordReset',
        path: AuthRoutes.requestPasswordReset(),
        label: trans('routes.requestPasswordReset.label'),
        children: [],
    },
    {
        key: 'samlReturn',
        path: AuthRoutes.samlReturn(),
        label: trans('routes.samlReturn.label'),
        children: [],
    },
];

export default authRoutes;
